/* eslint-disable camelcase */
import SemVer from 'semver';
import { defaultTheme } from '../theme';
import { type Device } from './columns';

type ColorAndTextParams = Pick<Device, 'platform' | 'fulcrum_version'>

const versionRules = (platform: Device['platform']) => (platform.includes('Android') ? ['>= 6.10.0'] : ['>= 2407.2.0']);

export function isOutDatedDevice(fulcrum_version: string, platform: string) {
  return !SemVer.satisfies(fulcrum_version, versionRules(platform)[0]);
}

export default function generateColorAndText({ platform, fulcrum_version }: ColorAndTextParams) {
  const { palette } = defaultTheme;
  let color = '';
  let text = '';

  if (isOutDatedDevice(fulcrum_version, platform)) {
    color = palette.fulcrum.main;
    text = 'This device requires updating to the latest version of Fulcrum';
  }

  return ({ color, text });
}
